import React, { Component } from 'react';
import style from './style/clickablelabel.scss';

export default class ClickableLabel extends Component {
    render() {
        const { children, onClick, classes = { root: {} }, isExpanded } = this.props;

        return (
            <div
                role="button"
                tabIndex="1"
                data-cy={`clickable-label ${isExpanded ? 'expanded' : 'expand'}`}
                className={ `${style.clickableLabel} ${classes.root ? classes.root : ''}` }
                onClick={ onClick }
            >
                { children }
            </div>
        );
    }
}
